const BOMB = 999
export default BOMB;